<template>
  <div class="loan-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="捐款荣誉榜"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--贷款详情-->
    <div>
      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>个人相片：</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="260"
               height="230"
               :src="detail.avatar"
             />
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>基本情况：</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <p>姓名：{{detail.name}}</p>
            <p>分庄：{{detail.village}}</p>
            <p>来自：{{detail.address}}</p>
            <p>捐赠金额：<span style="font-size: 26px; color:red;">{{detail.money}}</span>元</p>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>个人介绍：</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <div class="text-img" v-html="detail.description"></div>
          </div>
        </div>
      </div>

    </div>

    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'LoanList',
    data() {
        return {

        };
    },
    computed: {
      ...mapState({
          detail: state => state.root.donation_detail
      })
    },
    methods: {
      ...mapActions(['requestDonationShow']),
      onClickLeft() {
          this.$router.push({path: '/donation'});
      }
    },
    mounted() {
        this.requestDonationShow({"thit":this,"id":this.$route.query.id});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}

.text-img p img {
  width: 100% !important;
}
</style>
